<template>
  <el-dialog
    v-model="visible"
    title="附件"
    width="30%"
    :z-index="1000"
    :close-on-click-modal="false"
    @close="fileList = []"
  >
    <el-upload
      ref="upload"
      drag
      action=""
      accept=".xls, .xlsx, .png, .jpg, .pdf, .doc, .docx"
      :auto-upload="false"
      :limit="5"
      v-model:file-list="fileList"
    >
      <el-icon class="el-icon--upload"><upload-filled /></el-icon>
      <div class="el-upload__text">拖入文件或 <em>点击上传</em></div>
      <template #tip>
        <div class="el-upload__tip">
          只能上传 xls/xlsx/png/jpg/pdf/word/doc/docx
          格式文件且文件大小不超过10M
        </div>
      </template>
    </el-upload>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit()"
          v-loading="buttonLoading"
          :disabled="fileList.length == 0"
        >
          上传
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { ElMessage } from "element-plus";
import { ref } from "vue";
import { uploadFileMultipleNew } from "@/api/file";

const emits = defineEmits(["afterUpload"]);

const props = defineProps({
  fn: {
    type: Function,
    default: () => {},
  },
  uploadConfig: {
    type: Object,
    default: () => {
      // templateUrl:  模板下载的url
      // name :  模板文件名
    },
  },
});

// 弹窗控制
const visible = ref(false);

// 文件上传ref
const upload = ref(null);

// 文件列表
const fileList = ref([]);

// 按钮loading
const buttonLoading = ref(false);

// 弹窗打开  传入上传文件的函数
const handleDialogOpen = () => {
  visible.value = true;
};

// 文件大小限制
const checkFileSize = () => {
  for (let file of fileList.value) {
    const isLt10M = file.size / 1024 / 1024 < 10;
    console.log(`文件大小: ${file.size / 1024 / 1024}MB`);
    if (!isLt10M) {
      console.log(file);
      ElMessage.error(file.name + "文件大小不能超过10MB!");
      return false;
    }
  }
  return true;
};

// 点击保存
const handleSubmit = () => {
  if (fileList.value.length > 0) {
    if (!checkFileSize()) {
      return;
    }
    const reqBody = new FormData();
    fileList.value.forEach((item) => {
      if (item.raw) {
        reqBody.append("files", item.raw);
      }
    });
    uploadFileMultipleNew(reqBody).then((res) => {
      ElMessage.success("上传成功");
      visible.value = false;
      const result = res.data || [];
      console.log(result);
      emits("afterUpload", result);
    });
  }
};

defineExpose({
  handleDialogOpen,
});
</script>

<style lang="scss" scoped></style>